module.exports = __webpack_public_path__ + "img/howitworksmagnifyingglass.2426e7c0.svg";